import ErrorBoundary from "@/components/ErrorBoundary";
import ErrorPage from "@/components/ErrorBoundary/ErrorPage";
import routes from "@/routes";

import React from "react";
import { Route, Switch } from "react-router-dom";

import AuthRouteGuard from "./AuthRouteGuard";
import AppLayout from "./Layout";

export default () => (
  <AppLayout>
    <ErrorBoundary>
      <Switch>
        {routes.map((r, i) => (
          <AuthRouteGuard key={i} path={r.path} exact={true} admin={r.protected} Component={r.component} />
        ))}
        {/* Page not found */}
        <Route component={ErrorPage} />
      </Switch>
    </ErrorBoundary>
  </AppLayout>
);
